module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box box__selected"
  }, [_c('a', {
    staticClass: "box-back has-icon--left",
    on: {
      "click": function($event) {
        return _vm.sidebarChangePanel('types')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v(" " + _vm._s(_vm.$t('edit.sidebar.format')) + "\n    ")])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-d31853fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/themes/Header.vue
 ** module id = 910
 ** module chunks = 1
 **/